import type React from "react";
import { cn } from "src/shadcn/lib/utils";
import {
  Accordion as ShadcnAccordion,
  AccordionItem as ShadcnAccordionItem,
  AccordionTrigger as ShadcnAccordionTrigger,
  AccordionContent as ShadcnAccordionContent,
} from "src/shadcn/components/accordion";

const Accordion = (props: React.ComponentProps<typeof ShadcnAccordion>) => (
  <ShadcnAccordion {...props} />
);

const AccordionItem = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnAccordionItem>) => (
  <ShadcnAccordionItem className={cn("border-border", className)} {...props} />
);

const AccordionTrigger = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnAccordionTrigger>) => (
  <ShadcnAccordionTrigger
    className={cn("cursor-pointer", className)}
    {...props}
  />
);

const AccordionContent = (
  props: React.ComponentProps<typeof ShadcnAccordionContent>
) => <ShadcnAccordionContent {...props} />;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
